import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { getPalette } from 'owa-theme';
import { mergeStyleSets } from '@uifabric/styling';

export default function generateBorderStyle(colorScheme?: ColorScheme) {
    const rootColor = getPalette().neutralTertiary;
    const hoverColor = getPalette().neutralDark;
    const pressColor = colorScheme?.calPrimary || getPalette().themePrimary;

    const borderColor = mergeStyleSets({
        bottomBorder: {
            borderBottom: '1px solid ' + rootColor,
            selectors: {
                '&:hover': {
                    borderBottomColor: hoverColor,
                },
                '&:active,&:focus': {
                    borderBottomColor: pressColor,
                },
            },
        },

        fullBorder: [
            'full-border',
            {
                border: '1px solid ' + rootColor,
                selectors: {
                    '&:hover': {
                        borderColor: hoverColor,
                    },
                    '&:active,&:focus': {
                        borderColor: pressColor,
                    },
                },
            },
        ],

        dockingBorder: {
            borderBottom: '1px solid ' + rootColor,
            ['.full-border:hover &']: {
                borderColor: hoverColor,
            },
            ['.full-border:active &,.full-border:focus &']: {
                borderColor: pressColor,
            },
        },
    });
    return borderColor;
}
